import { render, staticRenderFns } from "./SBImg.html?vue&type=template&id=7569b764&scoped=true&"
import script from "./SBImg.ts?vue&type=script&lang=ts&"
export * from "./SBImg.ts?vue&type=script&lang=ts&"
import style0 from "./SBImg.css?vue&type=style&index=0&id=7569b764&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7569b764",
  null
  
)

export default component.exports